import axios from 'axios';
// MD5计算
import SparkMD5 from 'spark-md5';

// let loading;
import { Common } from 'js/class/Common';
import ERROR_TYPE from './errorConf';
class Data {
  constructor() {
    this.mockService = axios.create();
    this.service = axios.create({
      baseURL: '', // api的base_url
      timeout: 180000, // 请求超时时间
    });
    this.delayUnlockTime = 500; // 成功响应后延迟请求解锁的时间，即同一个接口成功响应延迟500ms后，才能再次继续响应
    this.lockRequest = {}; // 请求加锁集合
  }
  static getInstance() {
    if (!this.instance) this.instance = new Data();
    return this.instance;
  }
  getMock() {
    return this.mockService;
  }
  /**
   * @author:POPE
   * @description: 数据请求
   * @param  {} url
   * @param  {} params
   * @param  {} isToken=true
   * @param  {} loadingText='加载中...'
   */
  get(defaultParams = {}) {
    let service = this.service;
    let env = process.env;
    let params = {
      url: '',
      method: 'post',
      data: {},
      isToken: true,
      mode: 'mock',
      xmlHttpRequest: true,
      loadingText: '加载中...',
      headers: {},
    };
    Object.assign(params, defaultParams);

    let { url, data, method } = params;
    let urlString = url + JSON.stringify(data) + method;
    let urlHash = SparkMD5.hash(urlString);
    if (method === 'GET' || method === 'get') {
      /*
      params.url = `${params.url}${Common.getInstance().queryParams(
        params.data
      )}`
      */
      // 修复：空参时，默认不带问号
      let isInclude = params.url.lastIndexOf('?') > -1;
      let linkSymbol = isInclude
        ? JSON.stringify(params.data) === '{}'
          ? ''
          : '&'
        : '?';

      params.url = `${params.url}${Common.getInstance().queryParams(
        params.data,
        linkSymbol
      )}`;
    } else {
      if (this.lockRequest[urlHash]) {
        return;
      }
      if (typeof this.lockRequest[urlHash] === 'undefined') {
        this.lockRequest[urlHash] = true;
      }
      // topbar.show()
      window.fetchDispather.fetching = {
        flag: 'fetching',
        data: { pending: true },
      }; // 和iframe message 格式统一
    }
    switch (params.mode) {
      case 'mock':
        service = this.mockService;
        break;
      default:
      case 'real':
        service = this.service;
        break;
    }

    // 拦截器
    service.interceptors.request.use(
      (config) => {
        let token = ''; // 8711dc985f0d99ce65767d0d6146f49f33aa70f8
        // 在发送请求之前做某事，比如说 设置loading动画显示
        // loading = Loading.service({
        //   fullscreen: true,
        //   text: loadingText,
        //   // target: '#loading',
        //   background: 'rgba(0, 0, 0, 0.3)'
        // });
        // 设置token
        if (sessionStorage.getItem('user_info')) {
          token = JSON.parse(sessionStorage.getItem('user_info')).token;
        }
        if (params.isToken && token) {
          // 判断是否存在token和是否需要token，如果存在的话，则每个http header都加上token
          config.headers.token = `${token}`;
        }
        if (params.xmlHttpRequest) {
          config.headers.HTTP_X_REQUESTED_WITH = 'xmlhttprequest';
          config.headers['X-Requested-With'] = 'xmlhttprequest';
        }
        // config.headers['Accept-Apims'] = 'api';
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

        // if (config.url.indexOf(url) === -1) config.url = url + config.url;/*拼接完整请求路径*/
        return config;
      },
      (error) => {
        // 请求错误时做些事
        // loading.close();
        return Promise.reject(error);
      }
    );
    service.interceptors.response.use(
      (response) => {
        // 所有请求完成后都要执行的操作
        // 暂停加载动画
        // loading.close();
        return response;
      },
      function (err) {
        if (err.response) {
          switch (err.response.status) {
            case 401:
          }
        }
        return Promise.reject(err);
      }
    );

    // 解锁操作，如果有设置延时时间则延时解锁
    let unlockHandler = () => {
      if (this.delayUnlockTime) {
        setTimeout(() => {
          delete this.lockRequest[urlHash];
          window.fetchDispather.fetching = {
            flag: 'fetching',
            data: { pending: false },
          };
        }, this.delayUnlockTime);
      } else {
        delete this.lockRequest[urlHash];
        window.fetchDispather.fetching = {
          flag: 'fetching',
          data: { pending: false },
        };
      }
    };

    return new Promise((resolve, reject) => {
      let loopApi = [
        '/api/basic/conf/send_copy/total?',
        '/api/audit?audit_status=1',
        '/api/basic/tips?',
        '/api/pmc/stock_project?',
        '/api/engineering/conf/problem_pmc_num?',
        '/api/audit/conf/flow_form_undo_total?',
        '/api/wms/conf/spec_doc_total?',
        '/api/ship/conf/feed_ship_count?',
      ];
      let isNotLoopApi = false;
      if (
        !(
          loopApi.includes(params.url) &&
          ['get', 'GET', 'Get'].includes(params.method)
        )
      ) {
        isNotLoopApi = true;
      }
      service({
        url: params.url,
        method: params.method,
        // emulateJSON: true,
        // timeout: 10000,
        data: params.data, // Qs.stringify(param) || {}
        headers: params.headers,
        cancelToken: params.cancelToken,
      })
        .then((res) => {
          // loading.close();
          unlockHandler();
          resolve(res);
        })
        .catch((error) => {
          // loading.close();
          unlockHandler();
          reject(error);

          if (!(error && error.message && ERROR_TYPE[error.message])) {
            alert(`请求失败: ${error}`);
          }
        });
    });
  }
  /**
   * @author: POPE
   * @description: 获取json
   * @param {type}
   * @return:
   */
  getJson(url) {
    let envType = process.env.NODE_ENV;
    // if (envType === 'production') {
    // 生产环境
    // if (url.indexOf('/api') > -1) {
    //   url = url.replace('/api', '') // 去除/api
    // }
    // }
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        dataType: 'json',
        crossDomain: true,
        cache: false,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  /**
   * @author:POPE
   * @description:下载
   * @param  {} url
   * @param  {} param
   */
  down(url, param) {
    let query = [];
    for (let key in param) {
      query.push(key + '=' + param[key]);
    }
    url = url + '?' + query.join('&');
    window.open(url, 'down');
  }
}
export { Data };
